import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more"; // Import Highcharts-more for polar charts

HighchartsMore(Highcharts); // Initialize Highcharts-more

const SalariesChart = () => {
	const options = {
		chart: {
			polar: true,
			type: "line",
			height: 300,
			backgroundColor: "transparent",
			style: {
				fontSize: "16px",
			},
		},
		title: {
			text: null,
		},
		pane: {
			size: "80%",
		},
		credits: {
			enabled: false, // Disable the Highcharts credits
		},
		xAxis: {
			categories: ["Sales", "Development", "Accounts", "Support", "Finance", "Cleaners"],
			tickmarkPlacement: "on",
			lineWidth: 0,
		},
		yAxis: {
			gridLineInterpolation: "polygon",
			lineWidth: 0,
			min: 0,
		},
		tooltip: {
			shared: true,
			pointFormat: '<span style="color:{series.color}">{series.name}: <b>${point.y:,.0f}</b><br/>',
		},
		legend: {
			enabled: false, // Disable the legend
			align: "right",
			verticalAlign: "middle",
			layout: "vertical",
		},
		series: [
			{
				name: "Salaries",
				data: [43000, 70000, 10000, 65000, 20000, 25000],
				type: "area",
				fillOpacity: 0.3,
				lineWidth: 2.5,
				pointPlacement: "on",
				color: "#ff6b28",
				marker: {
					enabled: false, // Disables the markers (dots)
				},
			},
		],
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 500,
					},
					chartOptions: {
						pane: {
							size: "70%",
						},
					},
					condition: {
						maxWidth: 350,
					},
					chartOptions: {
						pane: {
							size: "50%",
						},
					},
				},
			],
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default SalariesChart;
